import LoadingAnimation from "components/LoadingAnimation/LoadingAnimation";
import SearchAndCreateBar from "components/SearchAndCreateBar/SearchAndCreateBar";
import { useHttpClient } from 'hooks/http-hook';
import { useAuth } from "providers/AuthProvider";
import { useEffect, useMemo, useState } from "react";
import { resolveFiles } from "utils";
import './Homepage.scss';

const Homepage = () => {
	const { token } = useAuth();
	const { sendRequest, isLoading } = useHttpClient();
	const [offCanvasPanelVisible, setOffCanvasPanelVisible] = useState(false);
	const [randomWallpaper, setRandomWallpaper] = useState(null);
	const [wallpaperUrl, setWallpaperUrl] = useState(null);

	useEffect(() => {
		const fetchRandomWallpaper = async () => {
      try {
        const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/wallpapers/random/1/false`, 'GET', null, {Authorization: `Bearer ${token}`}); // '/false' = sending privateMode false so homepage wallpapers only use public ones 
				const wallpaper = response.wallpapers?.[0] || null;
        setRandomWallpaper(wallpaper);
        if (wallpaper?.file) {
          const resolvedFiles = await resolveFiles([wallpaper.file]);
          setWallpaperUrl(resolvedFiles[0]?.fileUrl || null);
        } else {
          setWallpaperUrl(null);
        }
      } catch (err) {
        console.error('Error fetching random wallpaper:', err);
      }
    };

    fetchRandomWallpaper();
	}, [sendRequest, token]);

	// Toggles the Create Nav (with icons) Panel
	const toggleOffCanvasPanelVisibility= () => {
		setOffCanvasPanelVisible(!offCanvasPanelVisible);
	}

	const wallPaperStyles = useMemo(() => {
		let styles = {};
		if (randomWallpaper?.css) {
			try {
				styles = JSON.parse(randomWallpaper.css);
			} catch (err) {
				console.error("Invalid wallpaper CSS JSON:", err);
			}
		}
		if (wallpaperUrl) styles.backgroundImage = `url(${wallpaperUrl})`;
		return styles;
	}, [randomWallpaper, wallpaperUrl]);

	if (isLoading) return <LoadingAnimation asOverlay />;

	if (!randomWallpaper) {
    return (
      <div className="homepage">
				<SearchAndCreateBar
					className="search-and-create-bar--black-transparent"
					onUse={toggleOffCanvasPanelVisibility}
				/>
			</div>
    );
  }

	return (
		<div className="homepage" style={wallPaperStyles}>
			<SearchAndCreateBar
				className="search-and-create-bar--black-transparent"
				onUse={toggleOffCanvasPanelVisibility}
			/>
		</div>
	);
};

export default Homepage;